import log from 'salvo-lite/log'

class SelectURL {
    constructor (theme, elem) {
        this._select = elem
        this.swup = window.swup
    }

    onInit () {
        this._select.addEventListener('change', (e) => {
            log.debug('SelectURL', 'Change event', this)

            if (this._select.dataset.selectUrl === 'sort') {
                const urlSearchParams = new URLSearchParams(window.location.search)
                urlSearchParams.set(this._select.name, this._select.value)
                if (this.swup) {
                    this.swup.loadPage({
                        url: `?${urlSearchParams}`,
                        method: 'GET'
                    })
                } else {
                    window.location = `?${urlSearchParams}`
                }
            } else {
                if (this.swup) {
                    this.swup.loadPage({
                        url: this._select.value,
                        method: 'GET'
                    })
                } else {
                    window.location.href = this._select.value
                }
            }
        })
    }
}

export default SelectURL



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SelectURL.js